import { api } from 'api';
import { useApiCall } from '../useApiCall';
export var useDeleteCustomFieldDefinitionById = function (id) {
    return useApiCall(function (signal) { return api.customFields.apiCustomFieldDefinitionIdDelete(id, { signal: signal }); }, null, !!id, [id], { success: 'Custom field deleted' });
};
